import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IEmailProfileHolder, IResult } from "@coso-replicator/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class EmailProfilesService {
  private baseRoute: string = `/api/email-notification-profiles`;
  constructor(private http: HttpClient) {}

  get(): Observable<IEmailProfileHolder[]> {
    return this.http.get<IEmailProfileHolder[]>(this.baseRoute);
  }

  create(dto: IEmailProfileHolder): Observable<void> {
    return this.http.post<void>(this.baseRoute, dto);
  }

  update(name: string, dto: IEmailProfileHolder): Observable<void> {
    const encodedName = encodeURIComponent(name);
    return this.http.put<void>(`${this.baseRoute}/${encodedName}`, dto);
  }

  delete(name: string): Observable<void> {
    const encodedName = encodeURIComponent(name);
    return this.http.delete<void>(`${this.baseRoute}/${encodedName}`);
  }

  testConnection(profile: IEmailProfileHolder): Observable<IResult> {
    return this.http.post<IResult>(`${this.baseRoute}/test`, profile);
  }
}
